var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCode = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.819 12.624a.82.82 0 1 0 1.16 1.161l3.203-3.203a.82.82 0 0 0 0-1.16L8.98 6.215a.82.82 0 0 0-1.16 1.16L10.443 10 7.82 12.623Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.017 1.54A3.017 3.017 0 0 0 0 4.559v10.884a3.017 3.017 0 0 0 3.017 3.017h13.966A3.018 3.018 0 0 0 20 15.442V4.558a3.018 3.018 0 0 0-3.017-3.017H3.017ZM1.51 4.559c0-.833.675-1.508 1.508-1.508h13.966c.833 0 1.508.675 1.508 1.508v10.884c0 .833-.675 1.508-1.508 1.508H3.017a1.509 1.509 0 0 1-1.508-1.508V4.558Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/code.f87de31b90a58b5e8fae41004576f484.svg";